import { useRef, useEffect } from "react";

import { Message } from "../types/message";

export const useScrollToBottom = (messages: Message[] = []) => {
  const elementRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    setTimeout(() => {
      elementRef.current?.scrollTo({
        top: elementRef.current.scrollHeight,
        behavior: "smooth",
      });
    }, 100);
  };

  useEffect(() => {
    if (messages.length > 0) {
      scrollToBottom();
    }
  }, [messages.length]);

  return {
    elementRef,
    scrollToBottom,
  };
};
